module.exports = __webpack_public_path__ + "img/box.dc0641aa.jpg";